import React from 'react';
import PropTypes from 'prop-types';
import Section from '../components/Section';

class SectionResolver extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    name: PropTypes.string.isRequired,
    props: PropTypes.object,
    background: PropTypes.string,
    noPaddings: PropTypes.bool,
    fullSize: PropTypes.bool,
  };

  render() {
    const { id, name, props, background, fullSize, mobileFullSize, components, hideMenu } =
      this.props;

    const Component = components[name];

    if (!Component) {
      throw new Error(name);
    }

    return (
      <Section id={id} background={background} fullSize={fullSize} mobileFullSize={mobileFullSize}>
        <Component {...props} background={background} hideMenu={hideMenu} />
      </Section>
    );
  }
}

const createResolver = (components) => (props) => (
  <SectionResolver {...props} components={components} />
);

export default createResolver;
